import en from "./en.json";
import ru from "./ru.json";
import uk from "./uk.json";

export default {
  en,
  ru,
  uk
}